import { useContext } from 'react';
import { BreadcrumbsContext } from '../context/breadcrumbs-context';

export const useBreadcrumbsContext = () => {
  const breadcrumbsContext = useContext(BreadcrumbsContext);

  if (!breadcrumbsContext) {
    throw new Error(
      'breadcrumbsContext has to be used within <BreadcrumbsContext.Provider>',
    );
  }

  return breadcrumbsContext;
};
